<mat-card-content
    class="w-100-p mb-0 min-h-48"
    [ngClass]="{ pointer: isPerformanceReviewTileClickable }"
    (click)="isPerformanceReviewTileClickable ? openPerformanceTeamReviewPage() : null"
>
    <div class="p-24 stats-wrapper">
        <div fxLayout="column" class="chart-wrapper w-100-p" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="chart-title-wrapper mb-12 w-100-p">
                <div fxLayout="row">
                    <div fxLayoutAlign="center center" class="mr-8">
                        <mat-icon svgIcon="performance_review_tile"></mat-icon>
                    </div>
                    <label fxLayout="row" fxLayoutAlign="flex-start center" class="chart-title" tabindex="0">
                        {{ 'PAGE.SETTINGS.TAB.PERFORMANCE_REVIEW.TITLE' | translate }}
                    </label>
                </div>

                <div fxLayout="row" fxLayoutAlign="flex-end center">
                    <div class="w-2 h-2 bg-red-700 rounded-full mr-8" *ngIf="performanceTeamOverview.overdueTeamReviews"></div>
                    <mat-icon class="text-gray-600" *ngIf="isPerformanceReviewTileClickable"> keyboard_arrow_right </mat-icon>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-evenly center" class="w-100-p bg-zinc-50 rounded-sm text-gray-600" fxFlex="1 1 auto">
                <div fxLayout="column" fxLayoutAlign="center center">
                    <span class="text-xs">{{ performanceTeamOverview.inProgressTeamReviews }}</span>
                    <span class="tracking-widest text-xs leading-5 uppercase">{{ 'GENERAL.STATUS.IN_PROGRESS' | translate }}</span>
                </div>
                <div fxLayout="column" fxLayoutAlign="center center">
                    <span class="text-xs">{{ performanceTeamOverview.totalNumber }}</span>
                    <span class="tracking-widest text-xs leading-5 uppercase">{{ 'GENERAL.LABEL.TOTAL' | translate }}</span>
                </div>
            </div>
        </div>
    </div>
</mat-card-content>
